import { useEffect, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { Link } from "react-router-dom"

import { Badge, Button, Container, Table } from "reactstrap"
import Utils from "../../Utils"
import { getProyectos } from "../../datastore/actions/usuarioActions"

const BotonPDF = ({ Slug, type, fetchProyectos }) => {

    const [uploading, setUploading] = useState(false)

    const inputRef = useRef()

    const uploadFile = async (file) => {
        try {
            const formData = new FormData()
            formData.append("file", file)
            await Utils.API.SubirPDF(Slug, type, formData)
            alert("PDF subido satisfactoraimente!")
            // refresh
            fetchProyectos()
        } catch(err) {
            Utils.AlertError(err, "No se pudo actualizar el PDF")
        }
    }

    const onFileChoose = ({ target }) => {
        if(target.files[0]) {
            uploadFile(target.files[0])
        }
    }

    if(uploading === true) {
        return(
            <Badge color="primary">Subiendo...</Badge>
        )
    }

    return(
        <>
            <Button size="sm" onClick={() => { inputRef.current.click() }}>
                <i className="fa-solid fa-file-pdf"></i> Subir PDF
            </Button>
            <input accept=".pdf" onChange={onFileChoose} ref={inputRef} style={{ display: "none" }} type="file" />
        </>
    )
}

const ListarProyectos = () => {

    const dispatch = useDispatch()

    const proyectos = useSelector(({ usuario }) => usuario.proyectos)

    const fetchProyectos = () => {
        dispatch(getProyectos())
    }

    useEffect(() => {
        fetchProyectos()
    }, [])

    return(
        <Container>
            <Table hover bordered className="text-center my-2">
                <thead>
                    <tr className="table-info">
                        <th>#ID</th>
                        <th>Proyecto</th>
                        <th>Máximo de Cuotas</th>
                        <th>Mora Diaria</th>
                        <th>Inicial</th>
                        <th>Precios (PDF)</th>
                        <th>Planimetría (PDF)</th>
                        <th>Brochure (PDF)</th>
                    </tr>
                </thead>
                <tbody>
                    {proyectos.map(proyecto => (
                        <tr key={`Proyecto_${proyecto.idProyecto}`}>
                            <th scope="row">{proyecto.idProyecto}</th>
                            <td>
                                <Link to={`/Proyectos/${proyecto.Slug}`}>{proyecto.Nombre}</Link>
                            </td>
                            <td>{proyecto.MaxCuotas}</td>
                            <td>{proyecto.MoraDiaria}</td>
                            <td>{(proyecto.Inicial != 0) ? `${proyecto.Inicial}%`: "Sin Inicial"}</td>
                            <td>
                                {(proyecto.PreciosPDF == null) ?
                                    <span className="text-danger">Sin PDF</span>
                                    :
                                    <a href={`${Utils.Backend}/api/v1/Proyecto/${proyecto.Slug}/PreciosPDF`} target="_blank" className="btn btn-info btn-sm m-2">Ver PDF</a>
                                }<br />
                                <BotonPDF fetchProyectos={fetchProyectos} type="precios" Slug={proyecto.Slug} />
                            </td>
                            <td>
                                {(proyecto.PlanimetriaPDF == null) ?
                                    <span className="text-danger">Sin PDF</span>
                                    :
                                    <a href={`${Utils.Backend}/api/v1/Proyecto/${proyecto.Slug}/PlanimetriaPDF`} target="_blank" className="btn btn-info btn-sm m-2">Ver PDF</a>
                                }<br />
                                <BotonPDF fetchProyectos={fetchProyectos} type="planimetria" Slug={proyecto.Slug} />
                            </td>
                            <td>
                                {(proyecto.PartidaPDF == null) ?
                                    <span className="text-danger">Sin PDF</span>
                                    :
                                    <a href={`${Utils.Backend}/api/v1/Proyecto/${proyecto.Slug}/PartidaPDF`} target="_blank" className="btn btn-info btn-sm m-2">Ver PDF</a>
                                }<br />
                                <BotonPDF fetchProyectos={fetchProyectos} type="partida" Slug={proyecto.Slug} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    )
}

export default ListarProyectos